/*! Wave Colour Studio, (c) afzuigkapSpecialist.nl. Alle rechten voorbehouden. Kopieren, hergebruiken of doorverkopen zonder schriftelijke toestemming is niet toegestaan. */
/* Wave configurator: extra logica. Leesbare bron: claude/bron/wave-cfg-extra.src.js (project). */
(function(){
var CFG={
hideOnRequest:true,
onRequestLabels:[],
recommendPlasma:true
};
var root=document.querySelector('[data-wvc]');if(!root||root.dataset.wvcX)return;root.dataset.wvcX='1';
function ev(el){el.dispatchEvent(new Event('change',{bubbles:true}))}
function $all(sel,ctx){return [].slice.call((ctx||root).querySelectorAll(sel))}
var BASE={
'2176':{label:'Wit (RAL 9016)',hex:'#f6f6f6'},
'7229':{label:'Zwart (RAL 9005)',hex:'#0e0e10'},
'7391':{label:'Zwart (RAL 9005)',hex:'#0e0e10'},
'7395':{label:'Zwart (RAL 9005)',hex:'#0e0e10'},
'7543':{label:'Zwart (RAL 9005)',hex:'#0e0e10'},
'7933':{label:'Zwart (RAL 9005)',hex:'#0e0e10'}
};
function family(){var h=location.pathname.match(/\/products\/([^\/?#]+)/);h=h?h[1]:'';if(/sphere/.test(h))return '2176';var m=h.match(/(?:^|[^0-9])(\d{4})/);return m?m[1]:''}
function applyBase(){
var b=BASE[family()];if(!b)return;
var i=root.querySelector('input[name="wvc-color"][value=""]');if(!i||i.dataset.baseSet)return;i.dataset.baseSet='1';
i.dataset.label=b.label;i.dataset.mat='1';
var lab=i.closest('label');if(!lab)return;
var nm=lab.querySelector('.wvc__nm');if(nm)nm.textContent=b.label;
var d=lab.querySelector('.wvc__dot');if(d)d.style.setProperty('--c',b.hex);
var ch=root.querySelector('[data-wvc-chosen="color"]');if(ch&&i.checked)ch.textContent=b.label;
ev(i);
}
function leatherModel(){
var l=root.querySelector('input[name="wvc-leder"]:checked');if(l&&l.value)return true;
var f=document.querySelector('form.js-product-form-main'),i=f&&f.querySelector('input[name="id"]'),V={},t='';
try{V=JSON.parse(root.dataset.variants||'{}')}catch(e){}
if(i&&V[i.value])t=V[i.value].t||'';
return /leder/i.test((root.dataset.baseName||'')+' '+t+' '+location.pathname);
}
function oneColour(){
var on=leatherModel(),ins=$all('input[name="wvc-color"]');
ins.forEach(function(i){
if(!i.value||!/^2\s+kleur/i.test(i.dataset.label||''))return;
var lab=i.closest('label');if(lab)lab.style.display=on?'none':'';
if(on&&i.checked){var one=ins.filter(function(x){return x.value&&/^1\s+kleur/i.test(x.dataset.label||'')})[0]||ins[0];one.checked=true;ev(one)}
});
}
function fixLabels(){
var a=window.WVS&&WVS.api,box=root.querySelector('[data-wvc-custom]');if(!a||!box||box.hidden||!a.nCustom)return;
var l1=box.querySelector('[data-wvc-field-label]'),f2=box.querySelector('[data-wvc-field="2"] span');
if(a.nCustom()===2){if(l1)l1.textContent='Kleur 1 ('+a.m1+')';if(f2)f2.textContent='Kleur 2 ('+a.m2+')'}
}
function isPlasma(c){var i=c.querySelector('input');return /plasma/i.test((i.dataset.label||'')+' '+(i.dataset.sku||''))}
function filterStep(){
var r=root.querySelector('input[name="wvc-filter"]');var fs=r&&r.closest('fieldset');if(!fs||fs.dataset.wvcX)return;fs.dataset.wvcX='1';
var grid=fs.querySelector('.wvc__grid'),cards=$all('.wvc__card',grid);
var none=cards.filter(function(c){return c.querySelector('input').value===''})[0];
var real=cards.filter(function(c){return c!==none});
if(!real.length)return;
var lg=fs.querySelector('.wvc__legend');
if(lg&&lg.childNodes[1]&&lg.childNodes[1].nodeType===3)lg.childNodes[1].textContent='Recirculatiefilter ';
var hasP=real.some(isPlasma);
var p=document.createElement('p');p.className='wvc__hint';p.style.margin='0 0 .6rem';
p.textContent=hasP?'Deze Wave werkt op recirculatie: de lucht wordt door een filter gereinigd en blijft in de keuken. Een plasmafilter gaat volgens de fabrikant 12 tot 15 jaar mee en hoeft niet vervangen te worden. Een koolstoffilter kost minder in aanschaf, maar raakt na ongeveer 3 jaar verzadigd en moet dan vervangen worden.':'Deze Wave werkt op recirculatie: de lucht wordt door een filter gereinigd en blijft in de keuken. Kies hieronder het filter dat bij jouw model hoort.';
lg.insertAdjacentElement('afterend',p);
real.forEach(function(c){
var i=c.querySelector('input'),t=c.querySelector('.wvc__card-t'),d=c.querySelector('.wvc__card-d');
if(isPlasma(c)){
if(t)t.textContent=(i.dataset.label||'Plasmafilter plus').replace(/\s*\(.*\)\s*/,'');
if(d)d.textContent='Gaat volgens de fabrikant 12 tot 15 jaar mee en vraagt weinig onderhoud.';
}else if(/koolstof/i.test(i.dataset.label||'')){
if(t)t.textContent=(i.dataset.label||'Koolstoffilter').replace(/\s*\(.*\)\s*/,'');
if(d)d.textContent='Levensduur ca. 3 jaar, daarna vervangen.';
}
});
if(none)none.remove();
if(CFG.recommendPlasma&&hasP){
var pc=real.filter(isPlasma);
pc.forEach(function(c){grid.insertBefore(c,grid.firstChild)});
var first=real.filter(isPlasma)[0];
real.forEach(function(c){var o=c.querySelector('input');if(o.checked){o.checked=false}});
var ft=first.querySelector('.wvc__card-t');if(ft){var b=document.createElement('span');b.className='wvc__chosen';b.textContent=' Aanbevolen';ft.appendChild(b)}
var fi=first.querySelector('input'),qs='';try{qs=new URLSearchParams(location.search).get('filter')||''}catch(e){}
var want=qs&&real.filter(function(c){var o=c.querySelector('input');return !o.disabled&&(o.dataset.label||'').toLowerCase().indexOf(qs.toLowerCase())===0})[0];
var pick=want?want.querySelector('input'):(!fi.disabled?fi:real.map(function(c){return c.querySelector('input')}).filter(function(o){return !o.disabled})[0]);
if(pick){pick.checked=true;ev(pick)}
}else{
var any=real.map(function(c){return c.querySelector('input')}).filter(function(o){return !o.disabled})[0];
if(any){any.checked=true;ev(any)}
}
}
function hideOnRequest(){
if(!CFG.hideOnRequest)return;
$all('input[type=radio]').forEach(function(i){
var on=i.dataset.extra||CFG.onRequestLabels.indexOf(i.dataset.label||'')>-1;
if(!on)return;
var lab=i.closest('label');i.checked=false;i.disabled=true;if(lab)lab.remove();
});
$all('fieldset.wvc__step').forEach(function(fs){
var radios=$all('input[type=radio]',fs);if(!radios.length)return;
var info=radios.every(function(i){return i.dataset.info});
if(info){
if(radios.length<=1){
fs.hidden=true;fs.style.display='none';
if(radios[0]&&!radios[0].checked){radios[0].checked=true}
}
}
});
renumber();
}
function renumber(){
var n=0;$all('fieldset.wvc__step').forEach(function(fs){
if(fs.hidden||fs.style.display==='none')return;
var m=fs.querySelector('.wvc__num');if(m)m.textContent=String(++n);
});
}
function frameStep(){
var fs=root.querySelector('[data-wvc-frame-step]');if(!fs||fs.dataset.wvcX)return;fs.dataset.wvcX='1';
var L=$all('input[name="wvc-leder"]',fs),H=$all('input[name="wvc-hout"]',fs);
function none(list){var n=list.filter(function(i){return !i.value})[0];if(n){n.checked=true}}
fs.addEventListener('change',function(e){
var t=e.target;if(!t)return;
if(t.value){if(t.name==='wvc-leder')none(H);else if(t.name==='wvc-hout')none(L)}
var c=fs.querySelector('input:checked[value]:not([value=""])'),ch=root.querySelector('[data-wvc-chosen="bekleding"]');
if(ch)ch.textContent=c?(c.name==='wvc-leder'?'leder ':'hout ')+c.dataset.label:'geen';
});
function hideApp(){
[].slice.call(document.querySelectorAll('select[name^="properties[Houten bekleding"],select[name^="properties[Gekozen lederkleur"],select[name^="properties[Heb je al een plasmafilter"]')).forEach(function(sel){
if(sel.dataset.wvcHid)return;sel.dataset.wvcHid='1';sel.disabled=true;
var el=sel;while(el.parentElement&&el.parentElement.id!=='infiniteoptions-container'&&el.parentElement.querySelectorAll('select,input,textarea').length===1)el=el.parentElement;
el.style.display='none';
});
}
hideApp();
try{var mo=new MutationObserver(hideApp);mo.observe(document.body,{childList:true,subtree:true});setTimeout(function(){mo.disconnect()},15000)}catch(e){}
}
function init(){applyBase();frameStep();hideOnRequest();oneColour();filterStep();renumber();fixLabels()}
root.addEventListener('change',function(){oneColour();renumber();setTimeout(fixLabels,40)});
root.addEventListener('input',function(){setTimeout(fixLabels,40)});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
window.addEventListener('load',function(){init();fixLabels()});
})();
(function(){var W={"Clue (bog oak)":"clue-bog-oak","Ledger verticaal (bog oak)":"ledger-verticaal-bog-oak","Ledger horizontaal (bog oak)":"ledger-horizontaal-bog-oak","Leaf (walnut)":"leaf-walnut"};
function u(k,w){return "https://cdn.shopify.com/s/files/1/0851/6301/6534/files/wonderwall-studios-hout-"+k+".jpg?width="+w}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]})}
function init(){var fs=document.querySelector("[data-wvc-frame-step]");if(!fs||fs.dataset.wvcWood)return;fs.dataset.wvcWood="1";
[].slice.call(fs.querySelectorAll('input[name="wvc-hout"]')).forEach(function(i){var k=W[i.dataset.label],l=i.closest("label"),d=l&&l.querySelector(".wvc__dot");if(k&&d){d.style.background="url("+u(k,160)+") center/cover no-repeat";d.classList.add("wvc__dot--wood")}});
if(!document.getElementById("wvc-bek-css")){var st=document.createElement("style");st.id="wvc-bek-css";st.textContent=".wvc-bek{margin:.6rem 0 .2rem;display:flex;gap:.8rem;align-items:center}.wvc-bek[hidden]{display:none}.wvc-bek__img{flex:0 0 auto;width:140px;aspect-ratio:4/3;border-radius:10px;background:#eee center/cover no-repeat;box-shadow:inset 0 0 0 1px rgba(0,0,0,.08)}.wvc-bek__cap{margin:0;font-size:.85rem;line-height:1.4}@media (max-width:480px){.wvc-bek__img{width:110px}}";document.head.appendChild(st)}
var bx=document.createElement("div");bx.className="wvc-bek";bx.hidden=true;bx.innerHTML='<div class="wvc-bek__img" role="img"></div><p class="wvc-bek__cap" aria-live="polite"></p>';
var hints=fs.querySelectorAll(".wvc__hint"),last=hints[hints.length-1];if(last)fs.insertBefore(bx,last);else fs.appendChild(bx);
var im=bx.firstChild,cp=bx.lastChild;
function upd(){var c=fs.querySelector('input:checked[value]:not([value=""])');if(!c){bx.hidden=true;return}
var nm=c.dataset.label||"";if(c.name==="wvc-hout"&&W[nm]){im.style.background="url("+u(W[nm],600)+") center/cover no-repeat";im.setAttribute("aria-label","Houtstructuur "+nm);cp.innerHTML="Voorbeeld houten bekleding: <strong>"+esc(nm)+"</strong> (Wonderwall Studios). Alleen het motorhuis wordt bekleed.";bx.hidden=false;return}
var L=window.WVS&&WVS.LEATHER&&WVS.LEATHER[nm];if(c.name==="wvc-leder"&&L){im.style.background=L.url?"linear-gradient(135deg,rgba(255,255,255,.1),rgba(0,0,0,.15)),url("+L.url+") 0 0/72px 72px repeat":L.mean;im.setAttribute("aria-label","Lederstructuur "+nm);cp.innerHTML="Voorbeeld lederen bekleding: <strong>"+esc(nm)+"</strong>. Alleen het motorhuis wordt bekleed.";bx.hidden=false;return}
bx.hidden=true}
fs.addEventListener("change",function(){setTimeout(upd,0)});upd()}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();window.addEventListener("load",init)})();
/* 7. FRAME-voorbeeld (kleur, open zijframes, motorhuis met leder/hout, kleur naar keuze): staat sinds 4 okt (F6) in assets/wave-frame-preview.js (met ?v=f6+uur: de CDN cachet per v-waarde een jaar en negeert andere parameters; wijzigingen zijn zo binnen een uur zichtbaar). */
(function(){if(!/frame/.test(location.pathname)||window.__wvFramePrev)return;window.__wvFramePrev=1;var me=[].slice.call(document.scripts).map(function(x){return x.src}).filter(function(x){return x.indexOf('wave-cfg-extra.js')>-1})[0];if(!me)return;var s=document.createElement('script');s.src=me.split('?')[0].replace('wave-cfg-extra.js','wave-frame-preview.js')+'?v=f6'+Math.floor(Date.now()/36e5);document.head.appendChild(s)})();